import { Download, FileSpreadsheet, Package } from 'lucide-react';
import { motion } from 'framer-motion';

export default function Downloads() {
  const handleDownload = () => {
    window.location.href = '/downloads/Liste_Produits_AfriOne_BD.xlsx';
  };

  return (
    <div className="min-h-screen pt-20 lg:pt-24 bg-gradient-to-br from-primary/5 to-secondary/5">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-white rounded-3xl shadow-xl p-8 lg:p-12"
        >
          {/* Header */}
          <div className="text-center mb-12">
            <div className="w-20 h-20 rounded-full bg-gradient-to-br from-primary to-primary_hover flex items-center justify-center mx-auto mb-6">
              <FileSpreadsheet className="w-10 h-10 text-white" />
            </div>
            <h1 className="text-3xl lg:text-4xl font-bold text-text_primary mb-4">
              Téléchargements
            </h1>
            <p className="text-lg text-text_secondary">
              Accédez à la liste complète de vos produits
            </p>
          </div>

          {/* Download Card */}
          <div className="border-2 border-primary/20 rounded-2xl p-8 bg-gradient-to-br from-white to-primary/5">
            <div className="flex items-start gap-6 mb-6">
              <div className="w-16 h-16 rounded-xl bg-secondary flex items-center justify-center flex-shrink-0">
                <Package className="w-8 h-8 text-white" />
              </div>
              <div className="flex-1">
                <h2 className="text-2xl font-bold text-text_primary mb-2">
                  Liste des Produits AfriOne BD
                </h2>
                <p className="text-text_secondary mb-4">
                  Fichier Excel contenant tous les produits de votre catalogue
                </p>
                
                {/* File Info */}
                <div className="grid grid-cols-2 gap-4 mb-6">
                  <div className="bg-white rounded-lg p-4">
                    <p className="text-sm text-text_secondary mb-1">Format</p>
                    <p className="font-semibold text-text_primary">Excel (.xlsx)</p>
                  </div>
                  <div className="bg-white rounded-lg p-4">
                    <p className="text-sm text-text_secondary mb-1">Taille</p>
                    <p className="font-semibold text-text_primary">17 Ko</p>
                  </div>
                  <div className="bg-white rounded-lg p-4">
                    <p className="text-sm text-text_secondary mb-1">Produits</p>
                    <p className="font-semibold text-text_primary">502 articles</p>
                  </div>
                  <div className="bg-white rounded-lg p-4">
                    <p className="text-sm text-text_secondary mb-1">Colonnes</p>
                    <p className="font-semibold text-text_primary">3 (Nom, Prix, Qté)</p>
                  </div>
                </div>

                {/* Download Button */}
                <button
                  onClick={handleDownload}
                  className="w-full px-8 py-4 bg-gradient-to-r from-primary to-primary_hover text-white rounded-full font-semibold text-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center gap-3 hover:scale-105"
                >
                  <Download className="w-6 h-6" />
                  Télécharger le fichier Excel
                </button>
              </div>
            </div>

            {/* Additional Info */}
            <div className="mt-6 pt-6 border-t border-primary/10">
              <h3 className="font-semibold text-text_primary mb-3 flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-primary"></span>
                Contenu du fichier
              </h3>
              <ul className="space-y-2 text-text_secondary">
                <li className="flex items-start gap-2">
                  <span className="text-primary mt-1">✓</span>
                  <span>Nom complet de chaque produit (502 produits)</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-primary mt-1">✓</span>
                  <span>Prix en euros (actuellement à 0.00€ - à mettre à jour via /admin)</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-primary mt-1">✓</span>
                  <span>Quantité en stock pour chaque produit</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-primary mt-1">✓</span>
                  <span>Format professionnel avec en-têtes colorés</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Help Section */}
          <div className="mt-8 p-6 bg-blue-50 rounded-2xl border border-blue-100">
            <h3 className="font-semibold text-blue-900 mb-2 flex items-center gap-2">
              💡 Astuce
            </h3>
            <p className="text-blue-800 text-sm">
              Une fois téléchargé, vous pouvez modifier les prix dans Excel, puis utiliser le fichier 
              pour mettre à jour vos produits en masse via le Panel Admin (/admin).
            </p>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
